new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#app_list',
  data: {
    menuFilter: false,
    listOpened: false,
    listEx: localStorage.getItem('listOrder') ? localStorage.getItem('listOrder') : localStorage.setItem('listOrder', 0),
    listExMobile: localStorage.getItem('listOrderMobile') ? localStorage.getItem('listOrderMobile') : localStorage.setItem('listOrderMobile', 0)
  },
  methods: {
    filterPrice() {
      //chamadas para o filtro de preço
      function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#E9E9E9', '#F46036', controlSlider);
        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          fromSlider.value = from;
        }
      }

      function controlToInput(toSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#E9E9E9', '#F46036', controlSlider);
        setToggleAccessible(toInput);
        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toInput.value = from;
        }
      }

      function controlFromSlider(fromSlider, toSlider, fromInput) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#E9E9E9', '#F46036', toSlider);
        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          fromInput.value = from;
        }
      }

      function controlToSlider(fromSlider, toSlider, toInput) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#E9E9E9', '#F46036', toSlider);
        setToggleAccessible(toSlider);
        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toInput.value = from;
          toSlider.value = from;
        }
      }

      function getParsed(currentFrom, currentTo) {
        const from = parseInt(currentFrom.value, 10);
        const to = parseInt(currentTo.value, 10);
        return [from, to];
      }

      function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
        const rangeDistance = to.max - to.min;
        const fromPosition = from.value - to.min;
        const toPosition = to.value - to.min;
        controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition) / (rangeDistance) * 100}%,
      ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
      ${rangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} 100%)`;
      }

      function setToggleAccessible(currentTarget) {
        const toSlider = document.querySelector('#toSlider');
        if (Number(currentTarget.value) <= 0) {
          toSlider.style.zIndex = 2;
        } else {
          toSlider.style.zIndex = 0;
        }
      }

      const fromSlider = document.querySelector('#fromSlider');
      const toSlider = document.querySelector('#toSlider');
      const fromInput = document.querySelector('#fromInput');
      const toInput = document.querySelector('#toInput');
      let url = window.location.href;

      if (url.includes('?lp=')) {
        const params = new URLSearchParams(window.location.search)
        const firstParams = params.get('lp');
        const secondParams = params.get('hp');
        fromInput.value = firstParams;
        toInput.value = secondParams;
        fromSlider.setAttribute('value', firstParams);
        toSlider.setAttribute('value', secondParams);
        fillSlider(fromSlider, toSlider, '#E9E9E9', '#F46036', toSlider);
      } else {
        fillSlider(fromSlider, toSlider, '#E9E9E9', '#F46036', toSlider);
        setToggleAccessible(toSlider);
      }

      fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
      toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
      fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider);
      toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider);

      function handleSliderRelease() {
        let from = $('#fromInput').val();
        let to = $('#toInput').val();
        window.location = `?lp=${from}&hp=${to}`;
      }

      $(fromSlider).mouseup(handleSliderRelease);
      $(fromSlider).on('touchend', handleSliderRelease);

      $(toSlider).mouseup(handleSliderRelease);
      $(toSlider).on('touchend', handleSliderRelease);
    },
    changeList(list) {
      this.listEx = list;
      localStorage.setItem('listOrder', list);
    },

    changeListMobile(list) {
      this.listExMobile = list;
      this.listOpened = false;
      localStorage.setItem('listOrderMobile', list);
    }
  },
  mounted() {
    this.filterPrice();

    const filterSize = document.querySelector(".product-list__filters .product-filter--filters .product-filter__item--size .product-filter__sub-menu");
    if(filterSize) {
        const cloneFilterSize = filterSize.cloneNode(true);
        const elementDest = document.querySelector("#buy-sizes");
        if(cloneFilterSize && elementDest) {
            elementDest.append(cloneFilterSize);
        }
    } else {
        document.querySelector('#buy-sizes').classList.add('no-size');
    }
  },
});

document.addEventListener('DOMContentLoaded', () => {

  const thirdVitrine = document.querySelector('#product_list3');
  if (thirdVitrine) {
    $('#product_list3').slick({
      arrows: true,
      dots: false,
      infinite: false,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 700,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToScroll: 3,
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToScroll: 4,
            slidesToShow: 4,
          }
        }
      ]
    });

    $('#product_list3').on('afterChange', function (event, slick, currentSlide, nextSlide) {
      Blazy({
        selector: '.lazy-img',
        successClass: 'loaded-img',
        success: function (element) {
          setTimeout(function () {
            var parent = element.previousSibling;
            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
          }, 200);
        }
      });
    });
  }
})